<div class="d-flex flex-wrap gap-4">
  <app-mdb-button [text]="'CUSTOMERS.NEW'"
                  [iconClass]="'fas fa-plus'"
                  (onClick)="openNewCustomerModal()"></app-mdb-button>
</div>

<app-customers-table></app-customers-table>
